export default function WhyFast() {
  return (
    <section className="bg-white py-24">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6 leading-tight">
          高速開発は、
          <br className="hidden md:block" />
          最初の打ち合わせから始まっています。
        </h2>

        <p className="text-lg md:text-xl text-gray-600 leading-relaxed mb-16">
          私たちは単にAIで開発しているわけではありません。
        </p>

        <div className="space-y-12">
          <div className="bg-gray-50 rounded-2xl p-8 md:p-10">
            <div className="flex flex-wrap justify-center gap-3 mb-6">
              {["打ち合わせ", "仕様整理", "デザイン方針", "モック作成", "PoC開発"].map((tag) => (
                <span
                  key={tag}
                  className="bg-white border border-gray-200 text-gray-700 text-sm font-bold px-4 py-2 rounded-full whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
            <p className="text-xl md:text-2xl font-bold text-gray-800 leading-relaxed">
              その全てを、一貫したプロセスとして構造化しています。
            </p>
          </div>

          <div className="space-y-8 md:space-y-10">
            <p className="text-lg md:text-xl text-gray-600 leading-relaxed text-center">
              例えば、初回お打ち合わせでは議事をAIで分析するだけでなく、
              <br className="hidden md:block" />
              打ち合わせ内容を2つに分解します。
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* 感情データ */}
              <div className="bg-rose-50 border border-rose-100 rounded-2xl overflow-hidden text-left flex flex-col">
                <div className="w-full h-48 md:h-56 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20warm%20and%20empathetic%20business%20conversation%20scene%20between%20two%20professionals%20sitting%20at%20a%20minimalist%20table%20with%20soft%20natural%20lighting%2C%20discussing%20project%20details%20with%20thoughtful%20expressions%2C%20warm%20rose%20and%20cream%20tones%2C%20modern%20office%20background%20with%20subtle%20bokeh%2C%20professional%20corporate%20photography%20style%2C%20clean%20and%20minimal%20aesthetic%2C%20no%20text&width=800&height=400&seq=1&orientation=landscape"
                    alt="感情データ ヒアリングシーン"
                    title="感情データ ヒアリングシーン"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="p-8 md:p-10">
                  <span className="inline-block bg-rose-100 text-rose-700 text-xs font-bold px-3 py-1 rounded-full mb-4">
                    感情・感性データ
                  </span>
                  <p className="text-gray-700 leading-relaxed text-base md:text-lg">
                    AIに任せるのではなく、弊社の営業担当がお打ち合わせのヒアリングを元に、感情や感性に関する内容を構造化してAIに投入します。&nbsp;
                  </p>
                  <p className="text-gray-700 leading-relaxed text-base md:text-lg mt-4">
                    近年、IT企業においても「官能試験」が採用される事例があり、弊社もこの思想を開発に取り入れております。
                  </p>
                </div>
              </div>

              {/* 構造化データ */}
              <div className="bg-emerald-50 border border-emerald-100 rounded-2xl overflow-hidden text-left flex flex-col">
                <div className="w-full h-48 md:h-56 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20clean%20and%20modern%20database%20schema%20diagram%20visualization%20with%20interconnected%20nodes%20and%20relational%20tables%2C%20emerald%20green%20and%20white%20color%20scheme%2C%20digital%20technology%20aesthetic%2C%20floating%20geometric%20data%20structures%20on%20light%20background%2C%20minimal%20UI%20design%20style%2C%20software%20engineering%20concept%2C%20no%20text&width=800&height=400&seq=2&orientation=landscape"
                    alt="構造化データ データベース設計"
                    title="構造化データ データベース設計"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="p-8 md:p-10">
                  <span className="inline-block bg-emerald-100 text-emerald-700 text-xs font-bold px-3 py-1 rounded-full mb-4">
                    構造化データ
                  </span>
                  <p className="text-gray-700 leading-relaxed text-base md:text-lg">
                    業務要件についてはリレーショナルデータベース的設計手法を用いて厳密に構造化し、その上でAIに投入します。
                  </p>
                  <p className="text-gray-700 leading-relaxed text-base md:text-lg mt-4">
                    データ構造とその命名規則が精緻であれば、AIで生成するアプリケーションも正確になる。これは弊社の経験に基づく思想の一つです。
                  </p>
                </div>
              </div>
            </div>

            <div className="relative bg-gray-900 text-white rounded-2xl p-8 md:p-10">
              <p className="text-lg md:text-xl leading-relaxed mb-4">
                この二つの思想をエンジニアが統合することで、
              </p>
              <p className="text-xl md:text-2xl font-extrabold leading-relaxed">
                目的に合ったUIと業務仕様の適合を両立しつつ、
                <br className="hidden md:block" />
                AIによる高速開発を実現しています。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}